import React from "react";
import * as styles from "./PageResultsList.module.scss";
import StandardPageHit from "../StandardPageHit/StandardPageHit";
import { useHits } from "react-instantsearch";
import { AlgoliaGlobalSearchIndexNodeHit } from "src/gatsby/algolia/type";
import AlgoliaPagination from "components/Algolia/AlgoliaPagination";

type Props = {
  onPageChange: () => void;
};
const PageResultsList: React.FC<Props> = ({ onPageChange }) => {
  const { items, sendEvent } = useHits<AlgoliaGlobalSearchIndexNodeHit>();

  return (
    <div>
      <ul className={styles.list}>
        {items.map((hit) => (
          <li key={hit.objectID} className={styles.item}>
            <StandardPageHit hit={hit} algoliaSendEvent={sendEvent} />
          </li>
        ))}
      </ul>
      <div className={styles.moreButtonContainer}>
        <AlgoliaPagination onClick={onPageChange} />
      </div>
    </div>
  );
};

export default PageResultsList;
